<template>
  <div>
    <div class="home-page">
      <img class="logout-img" src="@/assets/home-page.svg" v-if="!isLogin"/>
      <Carousel autoplay :autoplay-speed="20000" loop v-model="value" v-if="isLogin">
        <CarouselItem>
          <img class="login-img" src="@/assets/login-home-page1.png"/>
        </CarouselItem>
        <CarouselItem>
          <img class="login-img" src="@/assets/login-home-page2.png"/>
        </CarouselItem>
      </Carousel>
    </div>
    <div class="carousel" v-if="isLogin">
      <h1 style="text-align: left; padding-left: 3cm; padding-top: 10px;">{{$t('LATEST_NEWS')}}</h1>
      <Carousel loop v-model="boradValue">
        <CarouselItem v-for="(group, index) in dataGroup" :key="index">
          <div class="flex-container-center">
            <div v-for="(item, index) in group" :key="index" style="padding: 0px 0.5cm 0px 0.5cm">
              <div class="card b-delta-green-item">
                <div class="card-body">
                  <img class="broad-page" src="@/assets/broad-page.jpg"/>
                  <h3 class="text-left">
                    <Icon :type="item.icon" color="DodgerBlue" slot="icon" class="mr-2" size="40" />{{
                      item.endEffectDate
                    }}
                    <Icon
                      class="text-danger"
                      size="30"
                      type="md-attach"
                      :style="[item.attachment ? {} : { display: 'none' }]"
                    /><br />
                  </h3>
                  <h6 class="card-text text-left broad-title" style="height: 15%"> <a @click="boardDetailModalEvent(item)">{{ item.title }} </a></h6>
                  <p class="card-text text-left" style="height: 60%">{{ item.subject }}</p>
                </div>
              </div>
            </div>
          </div>
        </CarouselItem>
      </Carousel>
    </div>
    <div class="csdPerson">
      <Row class="text-left">
        <img src="@/assets/png/delta_logo_rgb_2026.png" style="height: 60px; width: auto;padding-top: 14px;padding-bottom: 14px;padding-left: 14px;padding-right: 14px;"/>
        <a style="text-align: left; padding: 27px 1cm 10px 0px; color: #00A0E9;">{{$t('CONTACT_US')}}</a>
        <Col span="24">
          <div class="row" v-for="(group, index) in contactPerson" :key="index">
            <div class="col-lg-2" v-for="(item, index) in group" :key="index">
              <div class="team-member">
                <h5>{{ item.region }}</h5>
                <p class="text-muted"><Icon type="md-person" />{{ item.account }}</p>
                <p class="text-muted"><Icon type="ios-phone-portrait" />{{ item.phone }}</p>
                <p class="text-muted"><Icon type="md-mail" /> <a :href="'mailto:' + item.email">{{ item.email }}</a></p>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </div>
    <Modal :z-index="modalSize" :reset-drag-position="true" v-model="boardDetailModal" sticky :footer-hide="true" :header-hide="true" width="900" :styles="{ top: '90px' }">
      <div class="overflow-auto vh-68" style="">
        <div
          class="card b-delta-green "
          v-for="selectedAnnouncement in popupList"
          :key="selectedAnnouncement.uuid"
        >
          <div class="card-body">
            <h5 class="text-left">
              <Icon :type="selectedAnnouncement.icon" color="DodgerBlue" slot="icon" class="mr-2" size="30" />{{
                selectedAnnouncement.endEffectDate
              }}
              <strong class="ml-2" v-if="selectedAnnouncement.attachment">{{$t('APPENDIX')}}:</strong>
              <a
                v-if="selectedAnnouncement.attachment"
                href="javascript:void(0)"
                @click="downloadFile(selectedAnnouncement.attachment.id)"
              >
                {{ selectedAnnouncement.attachment.fileName }} </a
              ><br />
            </h5>
            <p v-html="selectedAnnouncement.content"></p>
          </div>
        </div>
      </div>
      <div class="text-center mt-2">
        <Button type="primary" @click="haveRead()">{{$t('READ')}}</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { typeList } from "../../util/enums/bulletin-board"
import { search, getCurrentUserReadRecord, read } from "../../util/api/auth/bulletin-board"
import { download } from "../../util/api/file/attachment"
import { mapGetters } from "vuex"
import { mapActions } from "vuex"
export default {
  name: "Home",
  mounted() {
    const vueInstance = this
    vueInstance.getBoard()
    vueInstance.windowResizeListener(vueInstance)
  },
  data() {
    return {
      value: 0,
      boradValue: 0,
      dataGroupTemp: [],
      dataGroup: [],
      boardDetailModal: false,
      selectedAnnouncements: [],
      popupList: [],
      contactPerson: []
    }
  },
  created() {
    window.addEventListener("resize", this.windowResizeListener)
    this.$authHttp
      .get("contact-person")
      .then((response) => {
        let result = []
        let temp = []
        response.data.forEach((element, index) => {
          if (Number(index) % 5 === 0 && Number(index) !== 0) {
            result.push(temp)
            temp = []
            temp.push(element)
          } else {
            temp.push(element)
          }
        })
        if (temp.length > 0) {
          result.push(temp)
        }
        this.contactPerson = result
      })
      .catch((error) => {
      })
  },
  destroyed() {
    window.removeEventListener("resize", this.windowResizeListener)
  },
  methods: {
    ...mapGetters(["getSmallDevice", "getLogin", "getUserProfile", "getModalSize"]),
    ...mapActions(["setLanguage", "setLogin", "toggleLoading"]),
    windowResizeListener(e) {
      if (e.target != undefined) {
        this.boradValue = 0
        this.buildDataGroup(e.target.innerWidth)
      }
    },
    buildDataGroup(innerWidth) {
      let vueInstance = this
      if (innerWidth < 868) {
        setDataGroup(vueInstance, vueInstance.dataGroupTemp, 1)
      } else if (innerWidth < 1268) {
        setDataGroup(vueInstance, vueInstance.dataGroupTemp, 2)
      } else if (innerWidth < 1664) {
        setDataGroup(vueInstance, vueInstance.dataGroupTemp, 3)
      } else if (innerWidth < 2518) {
        setDataGroup(vueInstance, vueInstance.dataGroupTemp, 4)
      } else {
        setDataGroup(vueInstance, vueInstance.dataGroupTemp, 5)
      }
    },
    boardDetailModalEvent(selectedAnnouncement) {
      const vueInstance = this
      vueInstance.popupList = [selectedAnnouncement]
      this.boardDetailModal = true
    },
    getBoard() {
      const vueInstance = this
      if (!vueInstance.getUserProfile().selectedGroup) {
        return;
      }
      vueInstance.selectedAnnouncements = [];
      vueInstance.popupList = [];
      search(vueInstance, true, true, null, null, [], [vueInstance.getUserProfile().selectedGroup.mainRoles[0].code], true, null, null, null)
        .then(response => {
          vueInstance.dataGroupTemp = response.data.content;
          this.buildDataGroup(window.innerWidth);
          return response.data.content.filter(bulletinBoard => bulletinBoard.isNotifiable);
        })
        .then(bulletinBoardList => {
          getCurrentUserReadRecord(vueInstance)
            .then(response => {
              bulletinBoardList.filter(bulletinBoard => {
                return response.data
                  .every(readRecord => readRecord.bulletinBoardUuid !== bulletinBoard.uuid);
              }).forEach(bulletinBoard => {
                vueInstance.popupList.push(bulletinBoard);
              });
              if (vueInstance.popupList.length > 0) {
                vueInstance.boardDetailModal = true;
              }
            });
        });
    },
    haveRead() {
      const vueInstance = this
      if (vueInstance.popupList.length == 0) {
        return;
      }
      read(vueInstance, vueInstance.popupList.map(bulletinBoard => bulletinBoard.uuid))
        .catch(error => {
          console.error(error);
        });
      vueInstance.boardDetailModal = false;
    },
    downloadFile(uuid) {
      let vueInstance = this
      vueInstance.toggleLoading(true)
      download(vueInstance, uuid)
    },
  },
  computed: {
    isLogin() {
      return this.getLogin()
    },
    headerStyle() {
      return {
        backgroundImage: `url(${this.image})`,
      }
    },
    systemRoles() {
      return this.getUserProfile().systemRoles
    },
    modalSize() {
      return this.getModalSize()
    }
  },
  watch: {
    systemRoles(arr) {
      const vueInstance = this
      vueInstance.getBoard(arr)
    },
  },
}

function setDataGroup(vueInstance, dataGroupTemp, number) {
  let result = []
  let temp = []
  dataGroupTemp.forEach((element, index) => {
    element.icon = typeList.find(item => item.value === element.type).icon
    if (Number(index) % number === 0 && Number(index) !== 0) {
      result.push(temp)
      temp = []
      temp.push(element)
    } else {
      temp.push(element)
    }
  })
  if (temp.length > 0) {
    result.push(temp)
  }
  vueInstance.selectedAnnouncements = result
  vueInstance.dataGroup = result
}
</script>

<style scoped>
.logout-img {
  height: 55vh;
  width: 100%;
}

.login-img {
  height: 35vh;
  width: 100%;
}

.demo-carousel {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.box {
  /* height: 400px; */
  border: 1px solid black;
  background-color: white;
}

.content {
  width: 100%;
  display: inline-block;
}

.time-box {
  display: inline-block;
}

.content-box {
  word-wrap: break-word;
  word-break: break-all;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 9;
  -webkit-box-orient: vertical;
  white-space: normal;
}

.footer-box {
  width: 100%;
  height: 10%;
  padding: 5px;
}

.user {
  display: flex;
  flex-wrap: wrap;
}

.user-content {
  padding: 5px;
  border-bottom: 2px solid black;
}
.vh-68 {
  max-height: 68vh !important;
}
</style>
